<div class="progress" [class.active]="isActive()" [class.animate]="shouldAnimate()" [style]="{width: getProgress()}">
</div>
